// 트래킹 O·X 표를 코드로 옮긴 곳. 판정 순서가 곧 우선순위다 — 취소를 가장 먼저 버리고(결제 화면을 떠날
// 때마다 결제 알림이 울리면 안 된다), 그다음 결제를 무엇보다 먼저 통과시키고, origin, 코드, status 순으로 본다.
// 전송 여부는 여기서만 정한다(어댑터는 판단하지 않는다).

import type { AppError } from './AppError'
import { CANCELED_CODE, type ReportingPolicy } from './policy'

const isTokenRefresh = (error: AppError, policy: ReportingPolicy) =>
  error.route !== undefined && policy.tokenRefreshRoutes.includes(error.route)

const isClientFault = (error: AppError, policy: ReportingPolicy) =>
  error.status === 429 || (error.code !== undefined && policy.clientFaultCodes.includes(error.code))

export const shouldDrop = (error: AppError, policy: ReportingPolicy): boolean => {
  if (error.code === CANCELED_CODE) return true

  if (error.flow === 'payment') return false

  if (error.origin === 'external' || error.origin === 'environment') return true

  if (error.code !== undefined && policy.expectedCodes.includes(error.code)) return true

  if (error.kind === 'API' && error.status !== undefined) {
    // 재발급 실패는 401(정상 만료)만 예상된 흐름이고 나머지는 전부 인증 서버 쪽 문제다
    if (isTokenRefresh(error, policy)) return error.status === 401
    if (error.status >= 500) return true
    if (error.status >= 400) return !isClientFault(error, policy)
  }

  return false
}
